import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function vibrate(pattern) {
  try {
    navigator.vibrate?.(pattern);
  } catch {
    /* not supported */
  }
}

const fmt = new Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 });
export function qty(n) {
  return fmt.format(Number(n) || 0);
}

export function fmtDate(iso) {
  if (!iso) return '';
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso);
  if (Number.isNaN(d.getTime())) return iso;
  if (d.getFullYear() >= 9000) return 'no date'; // Odoo placeholder
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', ...(d.getFullYear() !== new Date().getFullYear() ? { year: 'numeric' } : {}) });
}

export function daysFromToday(iso) {
  if (!iso) return null;
  const d = new Date(`${iso.slice(0, 10)}T00:00:00`);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((d - today) / 86400000);
}

/** Litres below a cubic metre, m³ above it. */
export function fmtVolume(litres) {
  const l = Number(litres);
  if (!l) return '';
  if (l >= 1000) return `${(l / 1000).toFixed(l >= 10000 ? 0 : 1)} m³`;
  return `${l >= 10 ? Math.round(l) : l.toFixed(1)} L`;
}

export function fmtWeight(kg) {
  const w = Number(kg);
  if (!w) return '';
  return `${w >= 10 ? Math.round(w) : Math.round(w * 10) / 10} kg`;
}

/* Order search: every typed word must appear in the PO name, supplier or
   vendor reference. Punctuation and spaces don't count, so "claim/2056421",
   "CLAIM 2056421" and "2056421" all find a vendor reference "CLAIM2056421". */
const squash = (s) => s.toLowerCase().replace(/[^0-9a-z]/g, '');
export function orderMatches(o, query) {
  const terms = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (!terms.length) return true;
  const hay = `${o.name} ${o.supplier} ${o.partner_ref || ''}`.toLowerCase();
  const flat = squash(hay);
  return terms.every((t) => hay.includes(t) || (squash(t) && flat.includes(squash(t))));
}
